import { Link, useLocation } from "react-router";
import { useRail } from "../../../shared/phone/media";
import { FlashsuiteMenu } from "../FlashsuiteMenu";
import { Logo } from "../Logo";
import { Icon, type IconName } from "../ui/Icon";
import type { Badges } from "./badges";

const PLACES: { to: string; label: string; icon: IconName; match: string[]; badge?: keyof Badges }[] = [
  // Why: a goal's own pages belong to Home, as they belong to the Command Center on a computer.
  { to: "/command", label: "Home", icon: "home", match: ["/command", "/goals"] },
  { to: "/needs", label: "Needs you", icon: "inbox", match: ["/needs"], badge: "needs" },
  { to: "/products", label: "Products", icon: "box", match: ["/products", "/partners"] },
  { to: "/library", label: "Library", icon: "book", match: ["/library"], badge: "lessons" },
  { to: "/connections", label: "Connections", icon: "plug", match: ["/connections"] },
];

/**
 * The rail down the left of an iPad: each place with its name under its icon, and Flashsuite's menu's one
 * button at the foot, where the account was (it opens toward the room it has). Shown only at the rail's widths.
 */
export function Rail({ badges }: { badges: Badges }) {
  const rail = useRail();
  const { pathname } = useLocation();
  if (!rail) return null;
  const lit = (match: string[]) => match.some((m) => pathname.startsWith(m));

  return (
    <nav className="pn-rail" aria-label="Main">
      <Link className="pn-rail-mark" to="/command" aria-label="Flashadz home">
        <Logo className="logo" />
      </Link>
      {PLACES.map(({ to, label, icon, match, badge }) => {
        const n = badge ? badges[badge] : 0;
        return (
          <Link key={to} to={to} className={lit(match) ? "pn-rail-item on" : "pn-rail-item"} aria-label={n ? `${label}, ${n} waiting` : label}>
            <Icon name={icon} />
            <span>{label}</span>
            {n ? (
              <b className="pn-badge" aria-hidden="true">
                {n > 99 ? "99+" : n}
              </b>
            ) : null}
          </Link>
        );
      })}
      <span className="pn-rail-grow" />
      <div className="pn-rail-fs">
        <FlashsuiteMenu compact />
      </div>
    </nav>
  );
}
